import React, { useState } from 'react';
import './NailArt.css';
import Header from '../../components/header/header';

const posts = [
  {
    id: 1,
    imageUrl: require('../../assets/nail_art/1.png'),
    caption: 'Beautiful sunset in Goa 🌅',
  },
  {
    id: 2,
    imageUrl: require('../../assets/nail_art/2.png'),
    caption: 'Working on a new app 💻📱',
  },
  {
    id: 3,
    imageUrl: require('../../assets/nail_art/3.png'),
    caption: 'React Native is amazing!',
  },
  
  {
    id: 3,
    imageUrl: require('../../assets/nail_art/6.png'),
    caption: 'React Native is amazing!',
  },

  {
    id: 1,
    imageUrl: require('../../assets/nail_art/8.png'),
    caption: 'Beautiful sunset in Goa 🌅',
  },
  {
    id: 1,
    imageUrl: require('../../assets/nail_art/10.png'),
    caption: 'Beautiful sunset in Goa 🌅',
  },
  {
    id: 1,
    imageUrl: require('../../assets/nail_art/11.png'),
    caption: 'Beautiful sunset in Goa 🌅',
  },
  {
    id: 1,
    imageUrl: require('../../assets/nail_art/12.png'),
    caption: 'Beautiful sunset in Goa 🌅',
  },
  {
    id: 1,
    imageUrl: require('../../assets/nail_art/13.png'),
    caption: 'Beautiful sunset in Goa 🌅',
  },
  // Add more posts as needed
];

function NailArt() {
    const [selectedImage, setSelectedImage] = useState(null);
  
    const openModal = (imageUrl) => {
      setSelectedImage(imageUrl);
    };
  
    const closeModal = () => {
      setSelectedImage(null);
    };
  
  return (
    <div className="portfolio-container">
      <Header />
      <div className="post-grid">
        {posts.map((post) => (
          <div className="post-card" key={post.id} onClick={() => openModal(post.imageUrl)}>
            <img src={post.imageUrl} alt={`Post ${post.id}`} />
          </div>
        ))}
      </div>

      {/* Modal */}
      {selectedImage && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage} alt="Full Size" />
          </div>
        </div>
      )}
    </div>
  );
}

export default NailArt;
